import React from "react";
import { withStyles } from "material-ui/styles";

import Avatar from "material-ui/Avatar";
import { withRouter } from "react-router-dom";

import Button from "material-ui/Button";
import Divider from "material-ui/Divider";
import { red, orange, lightGreen, grey, blue } from "material-ui/colors";

const styles = {
  root: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "row",
    paddingRight: 8
  },
  pending: {
    backgroundColor: orange["500"]
  },
  active: {
    backgroundColor: lightGreen["A700"]
  },
  suspended: {
    backgroundColor: red["500"]
  },
  closed: {
    backgroundColor: grey["500"]
  },
  review: {
    backgroundColor: blue["500"]
  },
  circle: {
    width: 16,
    height: 16,
    marginRight: 6
  }
};
const statuses = ["pending", "review", "active", "suspended", "closed"];

const AccountStatusFilterButtons = props => {
  const { classes, history } = props;
  const renderButtons = () => {
    return statuses.map((s, i) => (
      <Button
        color="primary"
        key={i}
        onClick={() => history.push(`/accounts?state=${s}`)}
      >
        <Avatar className={`${classes[s]} ${classes.circle}`} /> {s}
      </Button>
    ));
  };

  return (
    <div>
      <div className={props.classes.root}>{renderButtons()}</div>
      <Divider />
    </div>
  );
};

export { AccountStatusFilterButtons };

export default withStyles(styles, { name: "AccountStatusFilterButtons" })(
  withRouter(AccountStatusFilterButtons)
);



// WEBPACK FOOTER //
// ./src/AccountStatusFilterButtons.js